import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Translate from '../layout/Translate';

export default class TourMarker extends Component {

    componentDidMount() {


    }
    componentDidUpdate() {
    }
    componentWillUnmount() {
    }


    selectTour(tour) {

        this.props.actions.selectMapTour(tour);
        this.props.actions.fetchPostsIfNeeded(1, tour.id);
    }

    /*<div className="map__tour_title">
     {tour.title}
     <div className="map__tour_more">
     <Translate slug="map__more" />
     </div>
     </div>
     */

    render () {
        let { tour } = this.props;
        return (
            <div className="map__info" style={{position: 'absolute'}} onClick={this.selectTour.bind(this, tour)}>
                <div className={"map__tour " + (tour.hidden?'map__tour_hidden':'')}>
                    <div className="map__tour_info">
                        <span className="map__tour_title">
                            <span className="map__tour_shadow_right">
                                <span className="map__tour_shadow_center">
                                    {tour.title}
                                </span>
                            </span>
                        </span>
                    </div>

                </div>

            </div>



        );
    }
};



// WEBPACK FOOTER //
// ./src/common/components/map/TourMarker.js